import React from "react";

import {
  CheckoutForm,
  PaymentsCheckoutFormProps,
  PaymentSystemProvider,
} from "@/client/domains/payment-system";

import { Button } from "@/components/ui/button";
import { DialogContainer } from "@/components/ui/dialog";
import { Typography } from "@/components/ui/typography";

import { usePlanActivationStore } from "..";

//

export type CheckoutTabProps = PaymentsCheckoutFormProps & {
  title?: React.ReactNode;
  caption?: React.ReactNode;
};

//

export const CheckoutTab: React.FC<CheckoutTabProps> = ({ title, caption, ...props }) => {
  const tabsModel = usePlanActivationStore((s) => s.tabsModel);

  return (
    <PaymentSystemProvider>
      <DialogContainer className="grid gap-7" first last>
        <div className="space-y-1.5 text-left!">
          <Typography h4>{title || props.invoice.description || "Оплата"}</Typography>
          {typeof caption === "string" ? <Typography muted>{caption}</Typography> : caption}
        </div>
        <div>
          <CheckoutForm {...props} />
        </div>
        <div>
          {tabsModel.canBack() && (
            <Button variant={"outline"} icon={"ArrowLeft"} onClick={() => tabsModel.back()}>
              Назад
            </Button>
          )}
        </div>
      </DialogContainer>
    </PaymentSystemProvider>
  );
};
